import { render, staticRenderFns } from "./Alert-dismiss.vue?vue&type=template&id=32c0415a&scoped=true"
import script from "./Alert-dismiss.vue?vue&type=script&lang=js"
export * from "./Alert-dismiss.vue?vue&type=script&lang=js"
import style0 from "./Alert-dismiss.vue?vue&type=style&index=0&id=32c0415a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0415a",
  null
  
)

export default component.exports